import { Link } from "react-router-dom";
import LoginWrapperComponent from "./components/login-wrapper.component";
import AlertComponent from "@atoms/alert/alert.component";
import HelmetComponent from "@atoms/helmet/helmet.component";
import { APP_NAME } from "@constants/app.constants";
import LoadingComponent from "@atoms/loading/loading.component";
import "@core/scss/react/pages/page-authentication.scss";
import FormInputTextComponent from "@atoms/form-input/form-input-text/form-input-text.component";

const LoginTemplateComponent = ({
  templateModal: {
    username,
    password,
    isLoading,
    alertMessage,
    passwordVisibility,
  },
  templateEvents: { handleChange, handleSubmit, handleTogglePassword },
}) => {
  return (
    <LoginWrapperComponent>
      <HelmetComponent title={`Login Screen - ${APP_NAME}`} />
      {isLoading && <LoadingComponent />}
      <form className="auth-login-form mt-2" onSubmit={handleSubmit}>
        <div className="mb-1">
          <label htmlFor="username" className="form-label">
            Username
          </label>
          <FormInputTextComponent
            type="text"
            className="form-control"
            id="username"
            name="username"
            placeholder="Enter Username"
            value={username}
            onChange={(value) =>
              handleChange({ target: { value, name: "username" } })
            }
            isVertical={true}
            isRequired={true}
          />
        </div>

        <div className="mb-1">
          <label className="form-label" htmlFor="password">
            Password
          </label>

          <FormInputTextComponent
            type={passwordVisibility ? "text" : "password"}
            className="form-control"
            id="password"
            name="password"
            placeholder="Enter Password"
            value={password}
            onChange={(value) =>
              handleChange({ target: { value, name: "password" } })
            }
            inputIcon={passwordVisibility ? "eye" : "eye-off"}
            handleInputIconClick={handleTogglePassword}
            isVertical={true}
            isRequired={true}
          />
        </div>
        <div className="mb-1">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="remember-me"
              tabIndex="3"
            />
            <label className="form-check-label" htmlFor="remember-me">
              {" "}
              Remember Me{" "}
            </label>
            <Link to="/forgot-password" className="float-end">
              <small>Forgot Password?</small>
            </Link>
          </div>
        </div>

        <button className="btn btn-primary w-100" type="submit">
          Sign in
        </button>
      </form>
      {alertMessage && (
        <div style={{ marginTop: 16 }}>
          <AlertComponent
            type={alertMessage.type}
            message={alertMessage.message}
          />
        </div>
      )}
    </LoginWrapperComponent>
  );
};

export default LoginTemplateComponent;
